import fetch from '@ixigo/fetch';
import { getUserLocation } from '../location-services';
import type { Coords } from '../types';
import type {
	ApiResponse,
	LocationSuggestion,
	LocationSuggestionResponse,
} from './types';

type LocationSuggestionsPayload = {
	query: string;
	userCoords?: { latitude: number; longitude: number };
	pickupCoords?: { latitude: number; longitude: number };
	dropOffCoords?: { latitude: number; longitude: number };
};

export async function getLocationsSuggestions(
	payload: LocationSuggestionsPayload,
	opts: { signal: AbortSignal },
) {
	const res = await fetch
		.post('cabs/api/v1/autocomplete', {
			json: payload,
			signal: opts.signal,
		})
		.json<ApiResponse<LocationSuggestionResponse>>();
	return {
		items: res?.data?.suggestions ?? [],
	};
}

const mapCoords = (value: Coords | undefined) =>
	value ? { latitude: value.lat, longitude: value.lng } : undefined;
export async function getLocations(
	query: string,
	opts: {
		signal: AbortSignal;
		locationBias?: Coords;
		pickupCoords?: Coords;
		dropOffCoords?: Coords;
	},
) {
	const location = opts.locationBias || (await getUserLocation());
	return getLocationsSuggestions(
		{
			query,
			userCoords: location ? mapCoords(location) : undefined,
			pickupCoords: opts.pickupCoords
				? mapCoords(opts.pickupCoords)
				: undefined,
			dropOffCoords: opts.dropOffCoords
				? mapCoords(opts.dropOffCoords)
				: undefined,
		},
		{ ...opts },
	);
}

export async function getPlaceDetails(placeId: string) {
	const res = await fetch
		.get('cabs/api/v1/placeDetails', {
			searchParams: { placeId },
		})
		.json<ApiResponse<Required<LocationSuggestion>>>();
	return res.data;
}
